// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__9WbmE"};